import { render, staticRenderFns } from "./XtendTrafficCorr.vue?vue&type=template&id=ffedfb58&"
import script from "./XtendTrafficCorr.vue?vue&type=script&lang=js&"
export * from "./XtendTrafficCorr.vue?vue&type=script&lang=js&"
import style0 from "./XtendTrafficCorr.vue?vue&type=style&index=0&id=ffedfb58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports